import type { LookerDashboard } from '../types'

export function getLookerDashboardByName(list: LookerDashboard[], name: string) {
  return list.find((dashboard) => dashboard.name === name)
}
